// src/components/SEO.js

import React from "react";
import { Helmet } from "react-helmet-async";

const SEO = ({ title, description, name, type }) => {
  return (
    <Helmet>
      {/* Tags Padrão */}
      <title>{title}</title>
      <meta name="description" content={description} />

      {/* Tags Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />

      {/* Tags Twitter */}
      <meta name="twitter:creator" content={name} />
      <meta name="twitter:card" content={type} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
};

export default SEO;
